/**
 * IM PDU framing — matches C++ CImPdu / Flutter ImPdu (big-endian).
 */

const HEADER_LEN = 16;

let seqCounter = 0;
function nextSeq(): number {
  seqCounter = (seqCounter + 1) & 0xffff;
  if (seqCounter === 0) seqCounter = 1;
  return seqCounter;
}

export function buildPdu(
  serviceId: number,
  commandId: number,
  body: Uint8Array,
  seq?: number,
  version = 0,
  flag = 0,
  reversed = 0,
): Uint8Array {
  const seqNum = seq ?? nextSeq();
  const length = HEADER_LEN + body.length;
  const out = new Uint8Array(length);
  const view = new DataView(out.buffer);
  view.setUint32(0, length, false);
  view.setUint16(4, version, false);
  view.setUint16(6, flag, false);
  view.setUint16(8, serviceId, false);
  view.setUint16(10, commandId, false);
  view.setUint16(12, seqNum, false);
  view.setUint16(14, reversed, false);
  out.set(body, HEADER_LEN);
  return out;
}

export type ParsedPdu = {
  length: number;
  version: number;
  flag: number;
  serviceId: number;
  commandId: number;
  seqNum: number;
  reversed: number;
  body: Uint8Array;
};

export function tryReadOnePdu(buf: Uint8Array): { pdu: ParsedPdu; consumed: number } | null {
  if (buf.length < HEADER_LEN) return null;
  const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
  const length = view.getUint32(0, false);
  if (length < HEADER_LEN || length > 16 * 1024 * 1024) return null;
  if (buf.length < length) return null;
  const slice = buf.subarray(0, length);
  const v = new DataView(slice.buffer, slice.byteOffset, slice.byteLength);
  return {
    pdu: {
      length,
      version: v.getUint16(4, false),
      flag: v.getUint16(6, false),
      serviceId: v.getUint16(8, false),
      commandId: v.getUint16(10, false),
      seqNum: v.getUint16(12, false),
      reversed: v.getUint16(14, false),
      body: slice.subarray(HEADER_LEN, length),
    },
    consumed: length,
  };
}

export function appendBuffer(a: Uint8Array, b: Uint8Array): Uint8Array {
  const o = new Uint8Array(a.length + b.length);
  o.set(a, 0);
  o.set(b, a.length);
  return o;
}
